"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconTravelInsurance = function IconTravelInsurance(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M22.515 6.272a38 38 0 0 1-6.241 2.926 32 32 0 0 1-6.411 1.681c-.913.13-1.651.832-1.83 1.747l-.018.168c-.208 8.898 1.78 16.348 5.898 22.25l.291.41a24.84 24.84 0 0 0 8.323 7.557c.606.35 1.369.35 1.988-.007l.915-.55c4.143-2.516 6.518-4.402 8.395-7 4.208-5.818 6.296-13.211 6.2-22.04l-.01-.606-.014-.16a2.14 2.14 0 0 0-1.877-1.784 30 30 0 0 1-6.2-1.66 48 48 0 0 1-7.464-2.961c-.564-.329-1.327-.329-1.945.029m.303 2.13.697-.398a49.5 49.5 0 0 0 7.76 3.09 31.6 31.6 0 0 0 5.906 1.64l.738.124q.074.023.098.078l-.003-.118c.194 8.71-1.775 15.885-5.81 21.464-1.684 2.331-3.897 4.087-7.83 6.474l-.86.516a22.9 22.9 0 0 1-7.374-6.545l-.59-.831c-3.768-5.413-5.641-12.232-5.547-20.437l.008-.496.025-.038a.2.2 0 0 1 .12-.067 34 34 0 0 0 6.81-1.784A40 40 0 0 0 22.819 8.4M29 15h-1.5v4H31v11a4 4 0 0 1-3.008 3.876q.008.06.008.124a1 1 0 1 1-2 0h-4a1 1 0 1 1-1.992-.124A4 4 0 0 1 17 30V19h3.5v-4H19v-2h10zm-7.5 0h5v4h-5zM29 30a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-9h10zm-8.5 0v-7h1v7zm3 0v-7h1v7zm3-7v7h1v-7z",
    clipRule: "evenodd"
  })));
};

export { IconTravelInsurance, IconTravelInsurance as default };
